export const BREAKPOINTS = [480, 575, 768, 960, 1024, 1200] as const

export default BREAKPOINTS
